<template>
  <TabPanel :value="value">
    <slot></slot>
  </TabPanel>
</template>

<script setup lang="ts">
import TabPanel from 'primevue/tabpanel';

defineProps<{
  value: number | string;
}>();
</script>
